export default {
	getHeaders() {
		return {
			field: [
				{ field: "created", 				title: "Дата" },
				{ field: "name", 					title: "Название" },
				{ field: "chat_messages_count", 	title: "" },
				{ field: "status", 					title: "Статус" },
				{ field: "subject", 				title: "Область" },
				{ field: "work_type",		 		title: "Тип" },
				{ field: "quality_level", 			title: "Уровень" },
				{ field: "pages_number", 			title: "Страниц" },
				{ field: "due_date", 				title: "Дедлайн" },
				{ field: "author.username", 		title: "Автор" },
				{ field: "task", 					title: "Дела" },
			],

			tabs: [
				{
					key: "active",
					title: "Активные",
					pages: [
						"client_not_answer",
						"processing",
						"waiting_payment",
						"waiting_author",
						"in_progress",
						"patch_mode",
						"waiting_approve",
					]
				},
				{
					key: "history",
					title: "История",
					pages: [
						"completed",
						"failed_with_payout",
						"failed",
						"trash",
					]
				}
			]
		}
	}
};
